export enum FiltrosEnum {
    Directorios = 'filtros_directorios',
    Usuarios = 'filtros_usuarios',
    UsuariosArbolPermisos = 'filtros_usuarios_arbolAnidado',
    Oportunidades = 'filtros_oportunidades',
    OportunidadesPropuestasLineainfraestructura = 'filtros_oportunidades_propuestas_lineainfraestructura',
    OportunidadTareas = 'filtros_oportunidadtareas',
    Cuentas = 'filtros_cuentas',
    CuentasBancos = 'filtros_cuentas_bancos',
    CuentasContactos = 'filtros_cuentas_contactos',
    CuentasContactosFacturacion = 'filtros_cuentas_contactosfacturacion',
    CuentasProyectos = 'filtros_cuentas_proyectos',
    CuentasFacturas = 'filtros_cuentas_facturas',
    CuentasServicios = 'filtros_cuentas_servicios',
    Propuestas = 'filtros_propuestas',
    LineaInfraestructuraTipos = 'filtros_lineainfraestructuratipos',
    Bnis = 'filtros_bnis',
    Documentacion = 'filtros_documentacion',
    EmpleadoTareas = 'filtros_empleadotareas',
    Proyectos = 'filtros_proyectos',
    ProyectosFacturas = 'filtros_proyectos_facturas',
    ProyectosInfraestructura = 'filtros_proyectos_infraestructura',
    ProyectosInfraestructuraPropuesta = 'filtros_proyectos_infraestructurapropuesta',
    ProyectosServicioEventos = 'filtros_proyectos_servicio_eventos',
    Facturas = 'filtros_facturas',
    FacturasProyecto = 'filtros_facturasproyecto',
    FacturasMovimientos = 'filtros_facturas_movimientos',
    FacturasLineasFactura = 'filtros_facturas_lineasfactura',
    ServiciosProyecto = 'filtros_serviciosproyecto',
    HitosProyecto = 'filtros_hitosproyecto',
    HitosPropuesta = 'filtros_hitospropuesta',
    Estimaciones = 'filtros_estimaciones',
}

export enum OrdenEnum {
    Cuentas = 'orden_cuentas',
    CuentasContactos = 'orden_cuentas_contactos',
    CuentasContactosFacturacion = 'orden_cuentas_contactosfacturacion',
    CuentasBancos = 'orden_cuentasbancos',
    CuentasFacturas = 'orden_cuentas_facturas',
    CuentasProyectos = 'orden_cuentas_proyectos',
    CuentasServicios = 'orden_cuentas_servicios',
    Oportunidades = 'orden_oportunidades',
    OportunidadesPropuestasLineainfraestructura = 'orden_oportunidades_propuestas_lineainfraestructura',
    Propuestas = 'orden_propuestas',
    LineaInfraestructuraTipos = 'orden_lineainfraestructuratipos',
    Bnis = 'orden_bnis',
    Proyectos = 'orden_proyectos',
    EmpleadoTareas = 'orden_empleadotareas',
    OportunidadTareas = 'orden_oportunidadtareas',
    FacturasProyecto = 'orden_facturasproyecto',
    ServiciosProyecto = 'orden_serviciosproyecto',
    ProyectosInfraestructura = 'orden_proyectos_infraestructura',
    ProyectosInfraestructuraPropuesta = 'orden_proyectos_infraestructurapropuesta',
    ProyectosServicioEventos = 'orden_proyectos_servicio_eventos',
    ProyectosFacturas = 'orden_proyectos_facturas',
    HitosProyecto = 'orden_hitosproyecto',
    HitosPropuesta = 'orden_hitospropuesta',
    Estimaciones = 'orden_estimaiones',
    Facturas = 'orden_facturas',
    FacturasMovimientos = 'orden_facturas_movimientos',
    FacturasLineasFactura = 'orden_facturas_lineasfactura',
    Directorios = 'orden_directorios',
    Usuarios = 'orden_usuarios',
}
  